(function (root) {
  var NAME = /^[a-z0-9][a-z0-9-]{0,63}$/;
  var ARM = /^[A-Za-z0-9][A-Za-z0-9_-]{0,31}$/;
  var THEME_ID = /^[0-9]{1,20}$/;
  var THEME_VERSION = /^[0-9]{1,4}\.[0-9]{1,4}\.[0-9]{1,4}$/;
  var PLACEMENT = /^[a-z0-9][a-z0-9_-]{0,63}$/;
  var EXPOSURE_KEY = 'trybe_theme_exposure';

  // The arms the bootstrap in the head assigned, read back from <html data-exp-*>.
  function assignments(attributes) {
    var out = {};
    for (var i = 0; i < attributes.length; i++) {
      var name = String(attributes[i].name || '');
      if (name.indexOf('data-exp-') !== 0) continue;
      var experiment = name.slice(9);
      var arm = String(attributes[i].value || '');
      if (NAME.test(experiment) && ARM.test(arm)) out[experiment] = arm;
    }
    return out;
  }

  // Which theme rendered this page: the rollout arm of a Shopify rollout, read from the script tag.
  function themeExposure(data) {
    var values = data && typeof data === 'object' ? data : {};
    var id = String(values.themeId || '');
    var version = String(values.themeVersion || '');
    var name = String(values.themeName || '').slice(0, 100);
    if (!THEME_ID.test(id) || !THEME_VERSION.test(version) || name === '') return null;
    return { theme_id: id, theme_name: name, theme_version: version };
  }

  // Cart attributes that differ from the assignment; an empty patch means nothing to write.
  function attributePatch(current, assigned, prefix) {
    var attributes = current && typeof current === 'object' ? current : {};
    var patch = {};
    if (typeof prefix !== 'string' || !/^_[a-z0-9_]{1,31}$/.test(prefix)) return patch;
    for (var name in assigned) {
      if (!Object.prototype.hasOwnProperty.call(assigned, name)) continue;
      var key = prefix + name;
      if (attributes[key] !== assigned[name]) patch[key] = assigned[name];
    }
    return patch;
  }

  // Whether one of the "name:arm" pairs of a control is the arm this page stands in.
  function opens(pairs, assigned) {
    var list = String(pairs || '').split(' ');
    for (var i = 0; i < list.length; i++) {
      var pair = list[i].split(':');
      if (pair.length !== 2 || !NAME.test(pair[0]) || !ARM.test(pair[1])) continue;
      if (Object.prototype.hasOwnProperty.call(assigned, pair[0]) && assigned[pair[0]] === pair[1]) return true;
    }
    return false;
  }

  // Names of the entries that run only as a preview on an unpublished theme: they can be clicked through, never counted.
  function previews(text) {
    var out = {};
    var list;
    try { list = JSON.parse(String(text || '')); } catch (e) { return out; }
    if (!Array.isArray(list)) return out;
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].preview === true && NAME.test(String(list[i].name || ''))) out[list[i].name] = true;
    }
    return out;
  }

  // The place an experiment shows in, from the first element that gates it and names one (data-exp-placement).
  function placements(elements) {
    var out = {};
    for (var i = 0; i < elements.length; i++) {
      var placement = String(elements[i].getAttribute('data-exp-placement') || '');
      if (!PLACEMENT.test(placement)) continue;
      var pairs = ['data-exp-show', 'data-exp-hide', 'data-exp-enable'].map(function (name) { return elements[i].getAttribute(name) || ''; }).join(' ').split(' ');
      for (var j = 0; j < pairs.length; j++) {
        var experiment = pairs[j].split(':')[0];
        if (NAME.test(experiment) && !Object.prototype.hasOwnProperty.call(out, experiment)) out[experiment] = placement;
      }
    }
    return out;
  }

  // What experiment_exposure carries; the placement only where the page names a readable one.
  function exposurePayload(experiment, arm, placement) {
    var payload = { experiment: experiment, arm: arm };
    if (PLACEMENT.test(String(placement || ''))) payload.placement = placement;
    return payload;
  }

  var api = { assignments: assignments, attributePatch: attributePatch, themeExposure: themeExposure, opens: opens, previews: previews, placements: placements, exposurePayload: exposurePayload };
  root.themeExperiments = api;
  if (!root.document) return;

  var document = root.document;
  var script = document.currentScript;
  var data = script && script.dataset ? script.dataset : {};
  var exposure = themeExposure(data);
  var assigned = assignments(document.documentElement.attributes);
  var names = Object.keys(assigned);
  if (exposure === null && names.length === 0) return;

  // A control of an arm is disabled in the markup, so without script or in another arm it is never sent.
  function enableArms() {
    var controls = document.querySelectorAll('[data-exp-enable]');
    for (var i = 0; i < controls.length; i++) {
      if (!opens(controls[i].getAttribute('data-exp-enable'), assigned)) continue;
      controls[i].disabled = false;
      var chosen = controls[i].querySelectorAll('[data-exp-checked]');
      for (var j = 0; j < chosen.length; j++) chosen[j].checked = true;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enableArms);
  else enableArms();

  // Once per session and theme; without a readable store the page sends once instead of never.
  function firstOfSession(mark) {
    try {
      if (root.sessionStorage.getItem(EXPOSURE_KEY) === mark) return false;
      root.sessionStorage.setItem(EXPOSURE_KEY, mark);
    } catch (e) {}
    return true;
  }

  // The pixel is real once px.js replaced the stub; its init follows in the same deferred pass, so the first tick after the page loaded is late enough.
  function pixelReady() {
    return typeof root.trybe === 'function' && !root.trybe.q;
  }
  function track(event, payload) {
    try { root.trybe('track', event, payload); } catch (e) {}
  }
  function sendExposures() {
    var config = document.querySelector('[data-experiments]');
    var preview = previews(config ? config.textContent : '');
    var places = placements(document.querySelectorAll('[data-exp-placement]'));
    for (var i = 0; i < names.length; i++) {
      if (preview[names[i]]) continue;
      track('experiment_exposure', exposurePayload(names[i], assigned[names[i]], places[names[i]]));
    }
    if (exposure !== null && firstOfSession(exposure.theme_id + ':' + exposure.theme_version)) track('theme_exposure', exposure);
  }
  var tries = 0;
  function waitForPixel() {
    if (pixelReady()) { root.setTimeout(sendExposures, 0); return; }
    if (++tries > 40) return;
    root.setTimeout(waitForPixel, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', waitForPixel);
  else waitForPixel();

  if (names.length === 0 || typeof root.fetch !== 'function') return;

  // The order carries the arm: written once, on the first cart change of the page.
  var prefix = data.attributePrefix;
  var updateUrl = document.body && document.body.dataset ? document.body.dataset.cartUpdateUrl : '';
  var synced = false;
  document.addEventListener('cart:updated', function (event) {
    if (synced || !updateUrl) return;
    var cart = event && event.detail && event.detail.cart;
    if (!cart) return;
    var patch = attributePatch(cart.attributes, assigned, prefix);
    synced = true;
    if (Object.keys(patch).length === 0) return;
    root.fetch(updateUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: patch }),
    }).catch(function () { synced = false; });
  });
})(window);
